import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    position: 'relative',
  },
  select: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'space-between',
    height: '32px',
    padding: '7.5px 13px',
    backgroundColor: 'rgba(82, 58, 231, 0.1)',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  text: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    lineHeight: '14px',
  },
  strong: {
    fontWeight: 500,
  },
  arrow: {
    color: theme.palette.primary.main,
    alignSelf: 'center',
  },
}));
